import { StyleSheet } from '@react-pdf/renderer';

const cameraWeightReportStyles = StyleSheet.create({
  page: {
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 4,
    padding: '15 20',
  },
  main: {
    flexGrow: 1,
    padding: 10,
    backgroundColor: '#fff',
    fontSize: 12,
  },
  textSemiBold: {
    fontWeight: 500,
  },
  textBold: {
    fontWeight: 600,
  },
  textGrey: {
    color: '#808080',
  },
  textSm: {
    fontSize: 12,
  },
  textMd: {
    fontSize: 16,
  },
  textLg: {
    fontSize: 20,
  },
  justifyCenter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  justifyEnd: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  reportContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 5,
  },
  reportField: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 5,
  },
  borderBlack: {
    borderBottom: '1px solid #111111',
  },
  reportDetail: {
    display: 'flex',
    flexDirection: 'row',
    padding: 2,
    columnGap: 5,
  },
  col6: {
    display: 'flex',
    flexDirection: 'column',
    flex: 6,
    rowGap: 2,
  },
  image200: {
    width: '100%',
    maxHeight: '200px',
    objectFit: 'cover',
  },
  underline: {
    textDecoration: 'underline',
  },
});

export default cameraWeightReportStyles;
